<script lang="ts">
  /** Palette swatches (built-in and saved custom ones). */
  import type { AppController } from '../../app/controller.svelte';
  import { PALETTES, paletteCss } from '../../engine/render/palettes';
  import type { PaletteRef } from '../../shared/scene';

  interface Props {
    ctl: AppController;
    current: PaletteRef;
    onpick: (palette: PaletteRef) => void;
    /** Prefix for test ids (overall swatches keep the original `palette-<id>`). */
    testid?: string;
  }
  let { ctl, current, onpick, testid = 'palette' }: Props = $props();
  const custom = $derived(ctl.libraryVersion >= 0 ? ctl.library.listPalettes() : []);
</script>

<div class="palettes" role="radiogroup" aria-label="Palette">
  {#each PALETTES as p (p.id)}
    <button
      role="radio"
      aria-checked={p.id === current.id && !current.stops}
      aria-label={p.name}
      title={p.name}
      class="swatch"
      class:active={p.id === current.id && !current.stops}
      data-testid={`${testid}-${p.id}`}
      style:background={paletteCss(p)}
      onclick={() => onpick({ id: p.id })}
    ></button>
  {/each}
  {#each custom as p (p.id)}
    <button
      role="radio"
      aria-checked={p.id === current.id}
      aria-label={p.name}
      title={`${p.name} (custom)`}
      class="swatch custom"
      class:active={p.id === current.id}
      style:background={paletteCss({ ...p, stops: p.stops })}
      onclick={() =>
        onpick({ id: p.id, name: p.name, stops: p.stops, ...(p.cyclic ? { cyclic: true } : {}) })}
    ></button>
  {/each}
</div>

<style>
  .palettes {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 6px;
    margin-bottom: 10px;
  }
  .swatch {
    height: 24px;
    padding: 0;
    border: 2px solid transparent;
  }
  .swatch.active {
    border-color: #fff;
  }
  .swatch.custom {
    border-style: dashed;
    border-color: var(--border);
  }
  .swatch.custom.active {
    border-style: solid;
    border-color: #fff;
  }
</style>
